































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({
  name: "create-account-options",
  components: {}
})
export default class CreateAccountOptions extends Vue {
  get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }
  get isMobile() {
    return this.$store.state.isMobile;
  }

  created() {
    if (this.isLoggedIn) {
      this.$router.push("/");
    }
  }
   goToAccederConTarjetaSolidaridad(){
      this.$router.push("/acceder-con-tarjeta-solidaridad");
  }
  goToAcceder(){
      this.$router.push("/acceder");
  }
}
